export default [
	{
		header: 'Telemarketing',
	},
	{
		title: 'Calon Agen',
		icon: 'UserIcon',
		route: 'calon-agen',
	},
]
